import { Button, CircularProgress, IconButton, Tooltip } from "@mui/material";
import DeleteForever from "@mui/icons-material/DeleteForever";
import SyncIcon from "@mui/icons-material/Sync";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

import { Bucket, BucketNumberEnum } from "features/trading/buckets";
import { BucketActions } from "./useBucketActions";

interface BucketToolbarActionsProps {
  bucket: Bucket | undefined;
  actions: Pick<
    BucketActions,
    "sync" | "addAllHoldings" | "isSyncing" | "isAddingHeld" | "isDeleting"
  >;
  onDeleteClick: () => void;
}

/**
 * Per-bucket toolbar: "Add all holdings" (Bucket 2), "Sync" (Bucket 3) and
 * delete. Shared between the Buckets tab header and the edit modal.
 */
export const BucketToolbarActions = ({
  bucket,
  actions,
  onDeleteClick,
}: BucketToolbarActionsProps) => {
  if (!bucket) return null;

  return (
    <>
      {bucket.number === BucketNumberEnum.BUCKET_2 && (
        <Tooltip title="Add every stock the account currently holds">
          <Button
            variant="outlined"
            size="small"
            startIcon={
              actions.isAddingHeld ? (
                <CircularProgress size={16} />
              ) : (
                <PlaylistAddIcon />
              )
            }
            disabled={actions.isAddingHeld}
            onClick={() => actions.addAllHoldings()}
          >
            Add all holdings
          </Button>
        </Tooltip>
      )}
      {bucket.number === BucketNumberEnum.BUCKET_3 && (
        <Tooltip title="Add stocks the account acquired since the bucket was created">
          <Button
            variant="outlined"
            size="small"
            startIcon={
              actions.isSyncing ? <CircularProgress size={16} /> : <SyncIcon />
            }
            disabled={actions.isSyncing}
            onClick={() => actions.sync()}
          >
            Sync
          </Button>
        </Tooltip>
      )}
      <Tooltip title="Delete this bucket completely">
        <span>
          <IconButton
            color="error"
            size="small"
            disabled={actions.isDeleting}
            onClick={onDeleteClick}
          >
            <DeleteForever />
          </IconButton>
        </span>
      </Tooltip>
    </>
  );
};
